import { Module } from 'wrapper6'
import Swiper from 'swiper'

const $ = jQuery

export default class SliderWithLightbox extends Module {
  ready (app) {
    const productCoverWrappers = document.querySelectorAll('.mtt-product-cover')
    const textImageWrappers = document.querySelectorAll('.mtt-text-image')

    if (productCoverWrappers) {
      for (let i = 0; i < productCoverWrappers.length; i++) {
        const wrapper = productCoverWrappers[i]

        const slider = new Slider(wrapper)
      }
    }

    if (textImageWrappers) {
      for (let i = 0; i < textImageWrappers.length; i++) {
        const wrapper = textImageWrappers[i]

        const slider = new Slider(wrapper)
      }
    }
  }
}

class Slider {
  constructor (wrapper) {
    this.wrapper = wrapper
    this.swiperContainer = this.wrapper.querySelector('.swiper-container')

    if (this.swiperContainer) {
      this.slider = this.slider()
    }
  }

  slider () {
    const swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      watchOverflow: true,
      spaceBetween: 24,
      lazy: {
        loadPrevNext: true,
        checkInView: true
      },
      navigation: {
        nextEl: this.swiperContainer.querySelector('.arrow--next'),
        prevEl: this.swiperContainer.querySelector('.arrow--prev')
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      pagination: {
        el: this.swiperContainer.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      },
      observer: true,
      observeParents: true
    })

    if (!this.swiperContainer.classList.contains('no-lightbox')) {
      this.addLightBox()
    }

    return swiper
  }

  addLightBox () {
    const slides = this.wrapper.querySelectorAll('.swiper-slide')

    if (slides) {
      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i]

        slide.addEventListener('click', (e) => {
          if (!e.target.classList.contains('play-btn')) {
            this.openLightBox()
          }
        })
      }
    }
  }

  openLightBox () {
    if (!this.swiperContainer.classList.contains('open-lightbox')) {
      this.swiperContainer.classList.add('open-lightbox')

      this.slider.update()

      this.appendCloseBtn()

      this.addCloseClick()
    }
  }

  appendCloseBtn () {
    const closeBtn = document.createElement('div')

    closeBtn.classList.add('lightbox-close')

    this.swiperContainer.appendChild(closeBtn)
  }

  addCloseClick () {
    if (this.swiperContainer.querySelector('.lightbox-close')) {
      this.swiperContainer.querySelector('.lightbox-close').addEventListener('click', () => {
        this.removeLightbox()
      })

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.removeLightbox()
        }
      })
    }
  }

  removeLightbox () {
    if (this.swiperContainer.querySelector('.lightbox-close')) {
      this.swiperContainer.classList.remove('open-lightbox')

      this.slider.update()

      this.swiperContainer.querySelector('.lightbox-close').remove()
    }
  }
}

if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this)
    }
  }
}
